import React, { useState, useEffect, useRef } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import { BsCheck, BsX } from 'react-icons/bs';
import { FaCheck, FaTimes } from 'react-icons/fa';

const EditableLabel = ({
    text,
    onSave,
    children,
    inputGroupSize,
    as: Component = 'div',
    asProps,
}) => {
    const [isEditing, setIsEditing] = useState(false);
    const [input, setInput] = useState(text);
    const inputRef = useRef(null);

    useEffect(() => {
        if (isEditing) {
            inputRef.current.focus();
            setInput(text);
        }
    }, [isEditing]);

    useEffect(() => {
        function handleClickOutside(event) {
            const isInDraggableElement = (target) => {
                for (let i = 0; i < 10; i++) {
                    if (target.getAttribute('data-type') === 'editable-label') return true;
                    target = target.parentElement;
                    if (!target) return false;
                }
                return false;
            };

            if (!isInDraggableElement(event.target)) {
                setIsEditing(false);
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        setInput(text);
    }, [text]);

    const handleSave = () => {
        onSave(input);
        setIsEditing(false);
    };

    return isEditing ? (
        <InputGroup
            data-type="editable-label"
            onClick={e => e.stopPropagation()}
            size={inputGroupSize}
        >
            <Form.Control
                value={input}
                ref={inputRef}
                onChange={e => setInput(e.target.value)}
                onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        handleSave();
                    }
                    if (e.key === 'Escape') {
                        setIsEditing(false);
                    }
                }}
            />
            <Button
                variant="outline-primary"
                onClick={handleSave}
                className="d-flex align-items-center"
            >
                <FaCheck className="" />
            </Button>
            <Button
                variant="outline-secondary"
                onClick={() => setIsEditing(false)}
                className="d-flex align-items-center"
            >
                <FaTimes className="" />
            </Button>
        </InputGroup>
    ) : (
        <Component
            onClick={() => setIsEditing(true)}
            {...asProps}
            className={`editable-label-preview ${asProps?.className || ''}`}
        >
            {children}
        </Component>
    );
};

export default EditableLabel;
